import { Component, HostListener, Input, Pipe, PipeTransform, QueryList, ViewChildren } from '@angular/core';
import { TooltipDirective } from 'ng2-tooltip-directive';
import { ScreencastActionModelComponent } from 'src/app/screencast/screencast-action-model/screencast-action-model.component';
import { MatDialog } from "@angular/material/dialog";
import { Observable } from 'rxjs';
import { MatSnackBar } from "@angular/material/snack-bar";
import { SharedService } from "src/app/Services/sharedService";
import { TokenEncryptionService } from "src/app/Services/token-encryption.service";
import { AngularFireDatabase } from "@angular/fire/compat/database";
import { isRustAgentUser } from "src/app/agent-deploy/agent-deploy.config";
import { sysConfig } from "src/app/sysConfig";
import { CustomTimeAgoPipe } from "src/app/time-ago.pipe";
@Component({
  selector: 'user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css'],
  standalone: false
})
export class UserProfileComponent {
  @Input('user') user: any;
  @Input('isName') isName: any;
  @Input('userImageClass') userImageClass;
  @Input('sizeAvatar') sizeAvatar;
  @Input('forUserProfile') forUserProfile: boolean;
  @Input('showHealth') showHealth: Boolean = false;

  readonly sysConfig = sysConfig;

  // userProfileInfo: any;
  tooltipOptions: any = {
    'placement': 'right',
    "contentType": 'template',
    "maxWidth": "500px",
    "theme": 'light',
    "trigger": 'click',
    "hideDelayAfterClick": "200000",
    "zIndex": 1000
  }

  private dbPath: string | null = null;

  @ViewChildren(TooltipDirective)
  tooltipDirectives: QueryList<TooltipDirective>;
  showTooltip: boolean = false;

  tooltipShow: any = false;
  clickCount = 0;
  imageError: boolean = false;
  private healthTooltipTimeout: any = null;
  currentHealthTooltipUser: any = null;
  healthTooltipPosition: { top: number; left: number } = { top: 0, left: 0 };
  healthTooltipHovered: boolean = false;
  currentTooltipUser: any = null;
  tooltipPosition = { top: 0, left: 0 };
  tooltipHovered: boolean = false;

  constructor(
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    public _sharedService: SharedService,
    private db: AngularFireDatabase,
    private tokenEncryptionService: TokenEncryptionService,
    private customTimeAgoPipe: CustomTimeAgoPipe
  ) {
    this.dbPath = this.tokenEncryptionService.getEncryptedItem<string>('dbPath') as string;
  }

  /** Offline duration from Firebase lastOnlineAtTz (falls back to lastOnlineAt / status). */
  getOfflineAgo(): string {
    if (this.user?.lastOnlineAtTz) {
      return this.customTimeAgoPipe.transform(this.user.lastOnlineAtTz, 'lastActive');
    }
    if (this.user?.lastOnlineAt) {
      return this.customTimeAgoPipe.transform(this.user.lastOnlineAt);
    }
    if (
      this.user?.status &&
      this.user.status !== 'online' &&
      this.user.status !== 'not-using' &&
      this.user.status !== 'idle'
    ) {
      return this.customTimeAgoPipe.transform(this.user.status, 'lastActive');
    }
    return '';
  }

  get showRustAgentBetaBadge(): boolean {
    return sysConfig.rustAgentBetaBadgeEnabled && isRustAgentUser(this.user);
  }
  @HostListener("document:click", ["$event"])

  onDocumentClick(event: MouseEvent) {
    if (this.tooltipShow && this.clickCount) {
      // this.tooltipDirective.hide();
      this.tooltipDirectives.forEach((tooltip) => tooltip.hide());
      this.tooltipShow = true;
      // this.cdRef.detectChanges();
    } else {
      this.clickCount++;
      // this.hideDelayAfterClickFor = 100000000000000;
    }

    // if (!this.tooltipRef.nativeElement.contains(event.target)) {
    //   this.showTooltip = false;
    // }
  }
  openDialog(someComponent, data = {}): Observable<any> {
    const dialogRef = this.dialog.open(someComponent, { data, panelClass: 'centered-dialog' });
    return dialogRef.afterClosed();
  }
  openScreencastActionModel(user) {
    //  this._projectService.openScreencastModa();
    let obj = {
      userDetails: user,
      userId: user.id,
      dbPath: this.dbPath,
    };
    let data = obj;
    const dialogRef = this.openDialog(
      ScreencastActionModelComponent,
      data

      //maxHeight: "calc(100vh - 90px)",
    ).subscribe((response) => { });
  }
  userInfo() {
  }

  screenshotRequest(id, Status, name) {
    if (!navigator.onLine) {
      this._snackBar.open("Please check your internet connection?", "Undo", {
        duration: 3000,
      });
    } else {
      if (!this._sharedService.canTriggerScreenshotRequest(id)) {
        return;
      }
      let data = {
        type: "Requesting Screenshot",
        userName: name,
      };
      this._sharedService.showToast(data);
      setTimeout(() => {
        this.db.database.ref(`${this.dbPath}`).child(`${id}`).get().then((res) => {
          // Soft failure toast only — do not write ssRequest:false (agent ack race).
          if (res.val()?.ssRequest == null) {
            let data = {
              type: "Cant get screenshot",
              userName: name,
            };
            this._sharedService.showToast(data);
          }
        });
      }, 20000)
      // Match presence actions / tabs: idle agents are reachable.
      if (Status == "online" || Status == "idle") {
        this._sharedService.startOnDemandScreenshotRequest({
          employeeId: id,
          dbPath: this.dbPath || '',
          source: 'profile',
        });
      }
    }
  }

  // userStatus(userData: any) {
  //   console.log("Status Data ::: ", userData);
  // }

  getProfileImageUrl(): string | null {
    if (!this.user) return null;

    // Check for profile_image_url in meta first (from API response)
    if (this.user.meta && this.user.meta.profile_image_url) {
      return this.user.meta.profile_image_url;
    }

    // Check for profile_image in meta (alternative custom field)
    if (this.user.meta && this.user.meta.profile_image) {
      return this.user.meta.profile_image;
    }

    // Fallback to avatar_urls (WordPress default)
    if (this.user.avatar_urls && this.user.avatar_urls[96]) {
      return this.user.avatar_urls[96];
    }

    return null;
  }

  getDisplayImageUrl(): string {
    // Return profile image if available, otherwise return default placeholder
    return this.getProfileImageUrl() || this.getDefaultImageUrl();
  }

  getDefaultImageUrl(): string {
    // Return a data URI for a simple default placeholder icon
    // This is a simple person icon as SVG data URI
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 24 24' fill='%23B3B3B3'%3E%3Cpath d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'/%3E%3C/svg%3E";
  }

  getInitials(): string {
    if (!this.user || !this.user.name) return 'U';

    const nameParts = this.user.name.trim().split(' ');
    if (nameParts.length >= 2) {
      return (nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
    } else if (nameParts.length === 1) {
      return nameParts[0].charAt(0).toUpperCase();
    }

    return 'U';
  }

  onImageError(event: any): void {
    const currentSrc = (event.target as HTMLImageElement).src;
    const defaultImageUrl = this.getDefaultImageUrl();

    // If the error is on the default placeholder itself, show initials
    if (currentSrc === defaultImageUrl || currentSrc.includes('data:image/svg+xml')) {
      this.imageError = true;
      event.target.style.display = 'none';
    } else {
      // If a custom profile image fails to load, try showing the default placeholder
      // Only switch to default if we haven't already tried it
      if (!currentSrc.includes('data:image/svg+xml')) {
        (event.target as HTMLImageElement).src = defaultImageUrl;
      } else {
        // If default also fails, show initials
        this.imageError = true;
        event.target.style.display = 'none';
      }
    }
  }


  expandedFixKeys: { [key: string]: boolean } = {};

  toggleFixAccordion(key: string): void {
    this.expandedFixKeys[key] = !this.expandedFixKeys[key];
  }

  isFixExpanded(key: string): boolean {
    return !!this.expandedFixKeys[key];
  }

  isAnyActiveFixExpanded(): boolean {
    return Object.keys(this.expandedFixKeys).some(k => k.startsWith('active_') && !!this.expandedFixKeys[k]);
  }

  getReasonFixSteps(code: string): string[] {
    return this._sharedService.getReasonFixSteps(code);
  }

  showHealthTooltip(event: MouseEvent, user: any): void {
    this.expandedFixKeys = {};
    if (this.healthTooltipTimeout) {
      clearTimeout(this.healthTooltipTimeout);
      this.healthTooltipTimeout = null;
    }
    this.currentHealthTooltipUser = user;
    user.showHealthTooltip = true;

    const target = event.currentTarget as HTMLElement;
    const rect = target.getBoundingClientRect();
    const tooltipWidth = 360;

    let left = rect.left + (rect.width / 2) - (tooltipWidth / 2);
    if (left + tooltipWidth > window.innerWidth - 20) {
      left = window.innerWidth - tooltipWidth - 20;
    }
    if (left < 20) {
      left = 20;
    }

    const historyCount = user?.agentIntegrity?.healthHistory?.length || 1;
    const isUnhealthy = this._sharedService.getUserHealthState(user) === 'UNHEALTHY';
    const estimatedHeight = Math.min(320, 95 + (isUnhealthy ? 70 : 0) + Math.min(historyCount, 3) * 45);

    let top = rect.bottom + 8;
    if (top + estimatedHeight > window.innerHeight - 15) {
      top = Math.max(10, rect.top - estimatedHeight - 8);
    }

    this.healthTooltipPosition = { top, left };

    setTimeout(() => {
      if (this.currentHealthTooltipUser !== user) return;
      const card = document.querySelector('.health-tooltip-card') as HTMLElement;
      if (card && card.offsetHeight > 0) {
        const actualH = card.offsetHeight;
        let newTop = rect.bottom + 8;
        if (newTop + actualH > window.innerHeight - 15) {
          newTop = Math.max(10, rect.top - actualH - 8);
        }
        this.healthTooltipPosition = { top: newTop, left };
      }
    }, 0);
  }

  hideHealthTooltip(user?: any): void {
    this.healthTooltipTimeout = setTimeout(() => {
      if (!this.healthTooltipHovered) {
        this.clearHealthTooltip();
      }
    }, 150);
  }

  clearHealthTooltip(): void {
    if (this.healthTooltipTimeout) {
      clearTimeout(this.healthTooltipTimeout);
      this.healthTooltipTimeout = null;
    }
    if (this.currentHealthTooltipUser) {
      this.currentHealthTooltipUser.showHealthTooltip = false;
    }
    this.currentHealthTooltipUser = null;
    this.healthTooltipHovered = false;
    this.expandedFixKeys = {};
  }

  updateTooltipPosition(event: any, user: any): void {
    this.currentTooltipUser = user;
    const element = event.target as HTMLElement;
    const rect = element.getBoundingClientRect();

    // Position tooltip below the element with some offset
    this.tooltipPosition = {
      top: rect.bottom + 10, // 10px below the element
      left: rect.left
    };
  }

  clearTooltip(): void {
    this.currentTooltipUser = null;
    this.tooltipHovered = false;
  }
}

@Pipe({
  name: 'getUserRole',
  standalone: false
})
export class GetUsersRolePipe implements PipeTransform {

  transform(role: Array<string>): string {
    if (role) {
      return role.length > 1 ? role[1] : role[0];
    } else {
      return "";
    }
  }

}
